const scienceTabButtons = document.querySelectorAll(".science-wrapper .tab-heading");
const scienceTabContents = document.querySelectorAll(".science-wrapper .tab-content");

function scienceSplideInit(content) {
  content.querySelectorAll('.splide').forEach(el => {
    new Splide(el, {
      type       : 'slide',
      perPage    : 4,
      arrows     : true,
      drag       : true,
      gap        : '2rem',
      pagination : false,
      breakpoints: {
        1280: {
          perPage: 3,
        },
        767: {
          perPage: 2,
        },
        480: {
          perPage: 1,
        },
        640: {
          drag: true
        }
      }
    }).mount();
  });
}

scienceTabButtons.forEach((button, index) => {
  button.addEventListener("click", () => {
    scienceTabButtons.forEach(btn => btn.classList.remove("active"));
    scienceTabContents.forEach(c => c.classList.remove("active"));
    button.classList.add("active");
    scienceTabContents[index].classList.add("active");

    scienceSplideInit(scienceTabContents[index]);
  });
});

scienceTabContents.forEach(content => {
  if (content.classList.contains('active')) {
    scienceSplideInit(content);
  }
});
